import { Component, OnInit, forwardRef } from '@angular/core';
import { SmUiComponent } from '../sm-ui/sm-ui.component';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

@Component({
    selector: 'sm-simple-textarea',
    templateUrl: './sm-simple-textarea.component.html',
    styleUrls: ['./sm-simple-textarea.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmSimpleTextareaComponent),
            multi: true
        }
    ]
})
export class SmSimpleTextareaComponent extends SmUiComponent {}